// DB图表的混入对象
let chartMixin = {
  data () {
    return {
      SummaryInfoURL: this.getDomain() + 'bmsummary/get_summary_info', // 总体数据
      content: {},
      now: new Date()
    }
  },
  mounted: function () {
    this.getCount()
  },
  methods: {
    getCount () {
      this.axios.post(this.SummaryInfoURL, {
        token: sessionStorage.token
      }).then((data) => {
        if (data.data.err_code === 0) {
          this.content = data.data.content
          this.handleCount()
        } else {
          this.$alert('总体统计数据获取失败', '错误', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    handleCount () {
      this.content.income_total = this.content.income_total / 100
      this.content.seller_trans_rate = Number(this.content.seller_trans_rate * 100).toFixed(2) + '%'
    }
  },
  computed: {
    // 计算总日期数
    total_day: function () {
      return Math.ceil((this.now - 1565280000000) / 86400000)
    },
    // 计算总月数
    total_month: function () {
      return (this.now.getFullYear() - 2019) * 12 + (this.now.getMonth() - 6)
    }
  }
}

export default chartMixin
